var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightGlyph16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16.1489,
    viewBox: "0 0 16 16.1489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10122880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6285 4.30836C11.6285 3.71041 11.8405 3.1942 12.2687 2.76187C12.6949 2.32954 13.2015 2.1123 13.7909 2.1123C14.3803 2.1123 14.9315 2.32954 15.3597 2.76187C15.7859 3.1942 16 3.71041 16 4.30836C16 4.93642 15.7859 5.46554 15.3597 5.90002C14.9336 6.33235 14.41 6.54959 13.7909 6.54959C13.1719 6.54959 12.6927 6.33235 12.2687 5.90002C11.8405 5.46769 11.6285 4.93642 11.6285 4.30836Z",
    fill: "#FF4400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.95865 16.1489C3.57016 16.1489 0 12.5268 0 8.07444C0 3.6221 3.57016 0 7.95865 0V4.26521C5.88736 4.26521 4.20405 5.97517 4.20405 8.07444C4.20405 10.1737 5.88948 11.8837 7.95865 11.8837C10.0278 11.8837 11.7132 10.1759 11.7132 8.07444H15.9173C15.9173 12.5268 12.3471 16.1489 7.95865 16.1489Z",
    fill: "#FF4400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightGlyph16);
export default __webpack_public_path__ + "static/media/insight-glyph-16.32840c78c80b887e9f06d0f202c699f4.svg";
export { ForwardRef as ReactComponent };